import ApiService from "./api.service";
export default class ZoneService extends ApiService {
    static base_url = `${super.base_url}/zones`;

    static async forceDelete(param,axiosInstance) {
        const response = await axiosInstance.delete(`${super.base_url}/force/zones/${param}`);
        return response.data;
    }

}
